import { SMSAppointmentNotificationTemplateForm } from "../SMSAptNotifTemplateForm";

export const AddSMSAppointmentNotificationTemplate = () => {
  return <SMSAppointmentNotificationTemplateForm />;
};
